import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteCompany, getSpecificCompany } from "../../../redux/companySlice/companySlice";
import Swal from "sweetalert2";
import CompanyProfileData from "./MiniComponents/CompanyProfileData/CompanyProfileData";
import UpdateCompany from "../../Update/UpdateCompany/UpdateCompany";
import UpdateBranch from "../../Update/UpdateBranch/UpdateBranch";

export default function CompanyProfile() {
  const navigate = useNavigate();
  const { CompanyId } = useParams();
  const dispatch = useDispatch();

  const { specificCompany } = useSelector((state) => state.company);
  const [localCompany, setLocalCompany] = useState(null);

  useEffect(() => {
    dispatch(getSpecificCompany(CompanyId));
  }, [CompanyId, dispatch]);

  useEffect(() => {
    if (specificCompany) {
      setLocalCompany(specificCompany);
    }
  }, [specificCompany]);

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من استرجاع هذه الشركة بعد الحذف!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
    });

    if (result.isConfirmed) {
      try {
        await dispatch(deleteCompany(CompanyId)).unwrap();
        await Swal.fire("تم الحذف!", "تم حذف الشركة بنجاح.", "success");
        navigate("/Companies");
      } catch (err) {
        Swal.fire("خطأ!", err?.message || "حدث خطأ أثناء حذف الشركة، حاول مرة أخرى.", "error");
        // console.error("Error deleting company:", err);
      }
    }
  };

  if (!localCompany) return <div>جاري التحميل...</div>;

  return (
    <div className="main">
      <section className="companyProfile">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 ps-0 mb-5 position-relative">
              <CompanyProfileData company={localCompany} />
              <div className="d-grid gap-2">
                <Link to="/AddBranch" state={{ company_id: localCompany?.id }} className="btn btn-primary text-white">
                  <i className="fa fa-plus"></i> إضافة فرع
                </Link>
                <button onClick={handleDelete} className="btn btn-outline-danger">
                  <i className="fa-regular fa-trash-can"></i> حذف الشركة
                </button>
              </div>
            </div>
            <div className="col-md-8">
              <UpdateCompany company={localCompany} />
            </div>
            {localCompany?.branches?.map((branch) => (
              <UpdateBranch
                key={branch.id}
                branch={branch}
                onBranchDelete={(deletedId) => {
                  setLocalCompany((prev) => ({
                    ...prev,
                    branches: prev.branches.filter((b) => b.id !== deletedId),
                  }));
                }}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
